module.exports = function init_context_header($) {

  const $heading      = $('#site-name-location');
  const $heading_year = $('#site-name-location-year');
  if (!$heading.length && !$heading_year.length) return;

  const params = new URLSearchParams(window.location.search);
  const year   = params.get('site_year');

  // Back link to A1 summary page, shown only when both site_id and site_year
  // are present in the URL — a non-site record has nowhere to link back to.
  const site_id = params.get('site_id');
  const summary_slug = mlmp_settings.page_slug_activity_1_summary;
  const $backlink_el = $('#a1-summary-backlink');
  if ($backlink_el.length) {
    if (site_id && year && summary_slug) {
      const strings = (mlmp_settings.activity_1 || {});
      const label_tmpl = strings.summary_back_link_text || '{year} Monitoring Summary';
      const label = label_tmpl.replace('{year}', year);
      const summary_url = '/' + summary_slug + '/?site_id=' + site_id + '&site_year=' + year;
      $backlink_el.html('<a href="' + summary_url + '" class="mlmp-back-link">&larr; ' + label + '</a>');
    } else {
      $backlink_el.hide();
    }
  }

  // On the Activity 3 form, the "collected at your site?" toggle decides
  // whether this record is even going to a site — when it's off (No),
  // showing a site name here would be misleading, so only the year is
  // shown until it's switched to Yes. Pages without that field (e.g.
  // Activity 1) always show the site whenever one's known.
  const $collected_checkbox = $('.acf-field[data-name="collected_at_site"] input[type="checkbox"]');

  // get_site_context reads the *session's* currently-selected site, not the
  // URL's site_id — this stays in sync for normal per-site navigation (the
  // session is set whenever a site is selected), and is what makes the
  // standalone Non-Site Monarch Survival page's "Add a new record" flow
  // (no site_id in the URL at all) still able to show a site name here when
  // one's active in session. Always ask — even with no site_id in the URL —
  // so that flow isn't stuck blank; fall back to showing just the year
  // (from the URL) when there's truly no session site either.
  $.post(mlmp_settings.ajax_url, {
    action: 'get_site_context',
    ajax_nonce: mlmp_settings.nonce,
  }, (response) => {

    let site_text = '';
    if (response && response.site_name) {
      site_text = response.site_name;
      const location_parts = [response.city, response.state].filter(Boolean);
      if (location_parts.length) {
        site_text += ' | ' + location_parts.join(', ');
      }
    }

    function render() {
      const show_site = !$collected_checkbox.length || $collected_checkbox.is(':checked');
      const effective_site_text = show_site ? site_text : '';

      if ($heading.length) {
        effective_site_text ? $heading.text(effective_site_text) : $heading.hide();
      }

      if ($heading_year.length) {
        const text = year ? (effective_site_text ? effective_site_text + ' | ' + year : year) : effective_site_text;
        text ? $heading_year.text(text) : $heading_year.hide();
      }
    }

    render();
    $collected_checkbox.on('change', render);
  });

};
